// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 60px);
  padding: 24px;
  box-sizing: border-box;
  background: radial-gradient(ellipse at right, #d9ecff 0%, #eee9ff 42%, #ffffff 85%);
}
.home-page .home-content {
  text-align: center;
  animation: home-fade-in 0.5s ease-out both;
}
.home-page .home-icon {
  height: 20%;
  width: 40%;
  margin-bottom: 25px;
}
.home-page .home-content__line {
  margin: 0 0 12px;
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 500;
  color: #64748b;
}
.home-page .home-content__name {
  margin: 0;
  font-size: clamp(34px, 7vw, 25px);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
  color: #1e3a8a;
  background: linear-gradient(90deg, #004195 0%, #004195 50%, #004195 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media (prefers-reduced-motion: reduce) {
  .home-page .home-content {
    animation: none;
  }
}

@keyframes home-fade-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,mFAAA;AACF;AAME;EACE,kBAAA;EACA,0CAAA;AAJJ;AAOE;EACE,WAAA;EACA,UAAA;EACA,mBAAA;AALJ;AAQE;EACE,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;AANJ;AASE;EACE,SAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,cAAA;EACA,yEAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;AAPJ;AAYE;EACE;IACE,eAAA;EAVJ;AACF;;AAcA;EACE;IACE,UAAA;IACA,0BAAA;EAXF;EAaA;IACE,UAAA;IACA,eAAA;EAXF;AACF","sourcesContent":[".home-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 60px);\n  padding: 24px;\n  box-sizing: border-box;\n  background: radial-gradient(\n  ellipse at right,\n  #d9ecff 0%,\n  #eee9ff 42%,\n  #ffffff 85%\n);\n\n  .home-content {\n    text-align: center;\n    animation: home-fade-in 0.5s ease-out both;\n  }\n\n  .home-icon{\n    height: 20%;\n    width: 40%;\n    margin-bottom: 25px;\n  }\n\n  .home-content__line {\n    margin: 0 0 12px;\n    font-size: clamp(22px, 3vw, 30px);\n    font-weight: 500;\n    color: #64748b;\n  }\n\n  .home-content__name {\n    margin: 0;\n    font-size: clamp(34px, 7vw, 25px);\n    font-weight: 700;\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n    overflow-wrap: anywhere;\n    color: #1e3a8a; // fallback\n    background: linear-gradient(90deg, #004195 0%, #004195 50%, #004195 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n\n\n  @media (prefers-reduced-motion: reduce) {\n    .home-content {\n      animation: none;\n    }\n  }\n}\n\n@keyframes home-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
